import { render, staticRenderFns } from "./ManageSlides.vue?vue&type=template&id=7f765d21&scoped=true"
import script from "./ManageSlides.vue?vue&type=script&lang=js"
export * from "./ManageSlides.vue?vue&type=script&lang=js"
import style0 from "./ManageSlides.vue?vue&type=style&index=0&id=7f765d21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f765d21",
  null
  
)

export default component.exports